import { render } from "./preview-image.vue?vue&type=template&id=d3a89c38&scoped=true&ts=true"
import script from "./preview-image.vue?vue&type=script&lang=ts"
export * from "./preview-image.vue?vue&type=script&lang=ts"

import "./preview-image.vue?vue&type=style&index=0&id=d3a89c38&lang=scss&scoped=true"

import exportComponent from "/data/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d3a89c38"]])

export default __exports__